export const joinCollectionByProp = <T>(collection: T[] = [], prop: keyof T, joiner = ', '): string => {
    return collection.map((item) => item[prop]).join(joiner);
};
